import './portfolio-project-info.scss';
import { PortfolioDetailData } from '@/data/portfolio/portfolio-detail-data';
import { motion, useInView } from 'motion/react';
import { useRef } from 'react';

type Props = {
	projectInfo: PortfolioDetailData['projectInfo'];
};

const PortfolioProjectInfo = ({ projectInfo }: Props) => {
	const { title, description, clientName, duration, scope } = projectInfo;
	const ref = useRef<HTMLDivElement>(null);
	const inView = useInView(ref, { once: true, margin: '0px 0px -200px 0px' });
	return (
		<div className="portfolio-project-info-wrapper" ref={ref}>
			<motion.div
				className="project-info-title"
				initial={{ opacity: 0, y: 50 }}
				animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
				transition={{ duration: 0.8, ease: 'easeOut' }}
			>
				<h2>{title}</h2>
				<p>{description}</p>
			</motion.div>
			<motion.div
				className="project-info-client-name"
				initial={{ opacity: 0, y: 50 }}
				animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
				transition={{ duration: 0.8, ease: 'easeOut', delay: 0.4 }}
			>
				<article className="project-info-client-name-item">
					<h4>클라이언트</h4>
					<p>{clientName}</p>
				</article>
				<article className="project-info-client-name-item">
					<h4>프로젝트 기간</h4>
					<p className="value">{duration}</p>
				</article>
				<article className="project-info-client-name-item">
					<h4>서비스 범위</h4>
					<p>{scope}</p>
				</article>
			</motion.div>
		</div>
	);
};

export default PortfolioProjectInfo;
